import PropTypes from 'prop-types';
import { Alert, Button } from 'react-bootstrap';
import { format } from 'date-fns';

// "You have an unfinished form" bar shown above a form when useFormDraft
// finds a draft from earlier
export const DraftPrompt = ({ pendingDraft, onContinue, onDiscard, note }) => {
  if (!pendingDraft) return null;
  return (
    <Alert
      variant="info"
      className="mt-3 mb-0 d-flex flex-wrap align-items-center gap-2"
    >
      <div className="flex-1">
        You have an unfinished form from{' '}
        <strong>
          {format(new Date(pendingDraft.savedAt), 'dd MMM yyyy, HH:mm')}
        </strong>
        {note ? `. ${note}` : '.'}
      </div>
      <Button size="sm" variant="primary" onClick={onContinue}>
        Continue it
      </Button>
      <Button size="sm" variant="outline-secondary" onClick={onDiscard}>
        Discard
      </Button>
    </Alert>
  );
};

DraftPrompt.propTypes = {
  pendingDraft: PropTypes.shape({ savedAt: PropTypes.string }),
  onContinue: PropTypes.func.isRequired,
  onDiscard: PropTypes.func.isRequired,
  note: PropTypes.string
};

// Small "Draft saved on this device at HH:mm" line next to the submit button
export const DraftSavedNote = ({ savedAt, className = '' }) => {
  if (!savedAt) return null;
  return (
    <span className={`text-500 fs--1 ${className}`}>
      Draft saved on this device at {format(new Date(savedAt), 'HH:mm')}
    </span>
  );
};

DraftSavedNote.propTypes = {
  savedAt: PropTypes.string,
  className: PropTypes.string
};
